import { createTheme } from '@mui/material/styles'

// Types
import type { Direction } from '@mui/material/styles'

// Fonts
import IranSansXFont from '@/styles/fonts/iran-sans-x'
import RobotoFont from '@/styles/fonts/roboto'

// Brand book palette and type scale; scoped to pages that opt in through BrandProvider.
// Built without CSS variables so it overrides the site theme only inside its subtree.
const BrandThemeConfig = (dir: Direction) =>
	createTheme({
		direction: dir,
		palette: {
			// Smart turquoise: buttons, active icons and interactive elements
			primary: { ultralight: '#e6f5f5', light: '#b3e1e1', main: '#009c9c', dark: '#007a7a', ultradark: '#1c2b36', contrastText: '#fff' },
			// Bronze gold: CTA and key numbers only
			secondary: { ultralight: '#f6ecd8', light: '#d9b265', main: '#c29130', dark: '#9a7226', contrastText: '#fff' },
			// Soft lilac: emotional content and charts
			tertiary: { light: '#efe1f3', main: '#cba0d7', dark: '#ae6ac0', contrastText: '#1c2b36' },
			// Slate navy for headings, dark gray for body text
			text: { primary: '#1c2b36', secondary: '#4f5e69', disabled: '#c3cdd4' },
			// Silver gray for page backgrounds
			background: { default: '#e9ecef', paper: '#fff' }
		},
		shape: { borderRadius: 8 },
		components: {
			// White text on the brand turquoise is below 4.5:1; solid buttons use a slightly deeper teal that passes
			MuiButton: {
				styleOverrides: {
					root: {
						variants: [{ props: { variant: 'contained', color: 'primary' }, style: { backgroundColor: '#008080', '&:hover': { backgroundColor: '#006f6f' } } }]
					}
				}
			}
		},
		typography: {
			fontFamily: `${IranSansXFont.style.fontFamily}, ${RobotoFont.style.fontFamily}`,
			fontSize: 14
		}
	})

export default BrandThemeConfig
